export default {
  getTermFolder(id) {
    return require(`./fixtures/term_folders/${id}`)
  },

  getFixtureSheet(id) {
    return require(`./fixtures/sheets/${id}.json`)
  }
}


/** WEBPACK FOOTER **
 ** ./src/js/clients/mock/fixtures.js
 **/